
<div class="ladder">
  <ftu-block
    dismiss-key="ladder"
    icon="cl_ladder"
    title="This is the Ladder"
    description="The Ladder allows you to browse all the Card Ladder verified cards and sales. You can search, sort, and filter these cards to find specific cards and watch how different cards trend up and down for each of the algorithms. Click on a card to view its profile and start digging into the data."
  />

  <page-header title="Ladder">
    <template #actions>
      <saved-filters
        type="ladder"
        :query="query"
        :filters="filters"
        :is-filtering="isFiltering"
        @select="applySavedFilter"
      />
    </template>
  </page-header>

  <align flex collapse-end direction="flex-start">
    <shared-filters
      show-recent-searches
      placeholder="Search"
      :filters.sync="filters"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <align small-gap>
      <pill-dropdown
        v-if="isStaff"
        v-model="employee"
        :options="employeeFilterOptions"
      />

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>
  </align>

  <filter-results
    :is-filtering="isFiltering"
    :filters="filters"
    :results="numResults && numResults < 10000 ? numResults : null"
    @clear="clearFilters"
  />

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your query"
      description="Try searching for something else"
    />

    <template>
      <div class="list">
        <card-list-item
          v-for="card in cards"
          :key="card.id"
          :to="{ path: '/ladder', query: { ...$route.query, cardId: card.id } }"
          :card="card"
          :fields="itemFields"
          as="router-link"
        />
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="nextPage"
      />
    </template>
  </div>

  <scroll-top />
</div>
